import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
  Grid2 as Grid,
  Menu,
  MenuItem,
  Typography,
  Divider
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import LogoMobile from "../../assets/images/Logo_Marian.png";
import LogoDesktop from "../../assets/images/Logo_Marian.svg";
import FacebookMarian from "../../assets/images/facebook_marian.svg";
import InstagramMarian from "../../assets/images/instagram_marian.svg";
import Facebookzaks from "../../assets/images/facebook_zaks.svg";
import Instagramzaks from "../../assets/images/instagram_zaks.svg";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoNutret from "../../assets/images/110725-LOGO-NUTRET.png";
import LogoMili from "../../assets/images/Logo_Mili.svg";
import LogoZaks from "../../assets/images/Logo_Zaks.svg";
import LogoZaksHalloween from "../../assets/images/Logo_Zaks_Hall.svg";


import "./header.css";

function Header({ onSectionClick }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // Estado para manejar el menú de redes sociales

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const sections = ["EL SUEÑO", "PRODUCTOS", "INSPIRACIÓN", "CONTÁCTANOS", "SÍGUENOS"];
  const open = Boolean(anchorEl);

  const path = location.pathname.split("/");
  const section = path[1];
  const subsection = path[2];

  // Sincronizar activeSection con la ruta actual
  useEffect(() => {
    const getSectionFromPath = () => {
      switch (section) {
        case "contacto":
          return "CONTÁCTANOS";
        case "empresa":
          return "EL SUEÑO";
        case "productos":
          return "PRODUCTOS";
        case "inspiracion":
          return "INSPIRACIÓN";
        default:
          return null; // Para la página de inicio no hay sección activa
      }
    };

    const currentSection = getSectionFromPath();
    setActiveSection(currentSection);
  }, [location.pathname, section]);

  const logoMap = {
    mili: LogoMili,
    nutret: LogoNutret,
    zaks: LogoZaks,
    "zaks-halloween": LogoZaksHalloween
  };
  let Logo = logoMap[subsection] || (isMobile ? LogoMobile : LogoDesktop);

  const handleSocialMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSocialMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
    if (section === "CONTÁCTANOS") {
      navigate("/contacto");
    } else if (section === "EL SUEÑO") {
      navigate("/empresa");
    } else if (section === "PRODUCTOS") {
      navigate("/productos");
    } else {
      const sectionMap = {
        "INSPIRACIÓN": "inspiration"
      }
      if (window.location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          onSectionClick(sectionMap[section]);
        }, 100);
      } else {
        onSectionClick(sectionMap[section]);
      }
    }
    setDrawerOpen(false); // cerrar el drawer si estamos en mobile
  };

  const getHeaderClass = () => {
    switch (section) {
      case "contacto":
        return "header-contact";
      case "empresa":
      case "avisoprivacidad":
      case "inspiracion":
        return "header-secondary";
      case "submarcas":
        const submarcaClasses = {
          mili: "header-submarcas header-submarcas-mili",
          nutret: "header-submarcas header-submarcas-nutret",
          zaks: "header-submarcas header-submarcas-zaks",
          "zaks-halloween": "header-submarcas header-submarcas-zaks-halloween",
        };
        return subsection ? (submarcaClasses[subsection] || "") : "";
      case "productos":
        const productsClasses = {
          "bolitas-nuez": "header-products header-products-bolitas-nuez",
          danesas: "header-products header-products-danesas",
          "surtidos-majestic": "header-products header-products-surtidos-majestic",
          "surtidos-stylos": "header-products header-products-surtidos-stylos",
          "surtidos-suspiros": "header-products header-products-surtidos-suspiros",
          "surtidos-tradicional": "header-products header-products-surtidos-tradicional",
          "surtidos-clasico": "header-products header-products-surtidos-clasico",
          "tartaleta-fresa": "header-products header-products-tartaleta-fresa",
          "tartaleta-pina": "header-products header-products-tartaleta-pina",
          "tartaleta-zarzamora": "header-products header-products-tartaleta-zarzamora",
          "surtido-tartaleta": "header-products header-products-surtido-tartaletas",
          "danesas-canela": "header-products header-products-danesas-canela",
          "danesas-mantequilla": "header-products header-products-danesas-mantequilla",
          "orejitas-chocolate": "header-products header-products-orejitas-chocolate",
          "trazzos-chocolate": "header-products header-products-trazzos-chocolate",
          "orejitas-tubo": "header-products header-products-orejitas-tubo",
          "truffys-tubo": "header-products header-products-truffys-tubo",
          "dulce-ofrenda": "header-products header-products-dulce-ofrenda",
          "decembrinas": "header-products header-products-decembrinas",
          "temporalidades-navidad": "header-products header-products-temporalidades-navidad",
          "temporalidades-nochebuena": "header-products header-products-temporalidades-nochebuena",
          "nutret-fresa": "header-products header-products-nutret-fresa",
          "nutret-pina": "header-products header-products-nutret-pina",
          "nutret-zarzamora": "header-products header-products-nutret-zarzamora",
          "nutret-fibranuez": "header-products header-products-nutret-fibranuez",
          "nutret-linazaamaranto": "header-products header-products-nutret-linazaamaranto",
          "zaks": "header-products header-products-zaks",
          "zaks-halloween": "header-products header-products-zaks-halloween",
          "mili": "header-products header-products-mili",
        }
        return subsection ? (productsClasses[subsection] || "") : "";
      default:
        return "header";
    }
  }

  getHeaderClass();
  return (
    <AppBar position="static" className="header-container">
      <Toolbar
        className={getHeaderClass()}
        sx={{
          flexDirection: isMobile ? "row" : "column",
          justifyContent: isMobile ? "space-between" : "normal",
          alignItems: "center",
          px: 2,
          py: isMobile ? 1 : 2,
        }}
      >
        {isMobile ? (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "auto",
                position: "absolute",
                top: isMobile ? 16 : "auto",
              }}
            >
              <Link to="/">
                <IconButton color="inherit" aria-label="logo">
                  <img src={Logo} alt="Logo Marián" className="header-logo" />
                </IconButton>
              </Link>
            </Box>
            {/* Ícono de menú hamburguesa a la derecha */}
            <IconButton
              color="inherit"
              edge="end"
              onClick={() => setDrawerOpen(true)}
              className="menu-icon"
              sx={{
                position: "absolute",
                right: 16,
                top: 16,
                color: activeSection === "PRODUCTOS" ? "rgb(61, 28, 2)" : "inherit",
              }}
            >
              <MenuIcon />
            </IconButton>

            {/* Drawer */}
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            >
              <Box
                sx={{ width: 250 }}
                role="presentation"
                onClick={() => setDrawerOpen(false)}
              >
                <List>
                  {sections.map((section) => (
                    <ListItem key={section} disablePadding>
                      <ListItemButton onClick={() => handleSectionClick(section)}>
                        <ListItemText
                          primary={section}
                          primaryTypographyProps={{
                            sx: {
                              color: activeSection === section ? "#E66671" : "#3D1C02",
                              fontWeight: "700",
                              fontSize: "12px"
                            },
                          }}
                        />

                      </ListItemButton>
                    </ListItem>
                  ))}
                  <Box sx={{ padding: "10px" }}>
                    <Box className="social-container-marian">
                      <Typography variant="body2" className="social-title-marian">
                        Marián®
                      </Typography>
                      <Divider variant="middle" className="social-divider-marian" />
                      <Box className="social-icons-marian">
                        <MenuItem>
                          <a href="https://www.facebook.com/MarianGalletas" target="_blank" rel="noopener noreferrer">
                            <img src={FacebookMarian} alt="Facebook Marian" className="social-icon" />
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a href="https://www.instagram.com/galletasmarian/" target="_blank" rel="noopener noreferrer">
                            <img src={InstagramMarian} alt="Instagram Marian" className="social-icon" />
                          </a>
                        </MenuItem>
                      </Box>
                    </Box>
                    <Box className="social-container-zaks">
                      <Typography variant="body2" className="social-title-zaks">
                        Zak's®
                      </Typography>
                      <Divider variant="middle" className="social-divider-zaks" />
                      <Box className="social-icons-zaks">
                        <MenuItem>
                          <a href="https://www.facebook.com/ZaksMexicoOficial" target="_blank" rel="noopener noreferrer">
                            <img src={Facebookzaks} alt="Facebook Zak's" className="social-icon" />
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a href="https://www.instagram.com/zaksmexico/" target="_blank" rel="noopener noreferrer">
                            <img src={Instagramzaks} alt="Instagram Zak's" className="social-icon" />
                          </a>
                        </MenuItem>
                      </Box>
                    </Box>
                  </Box>
                </List>
              </Box>
            </Drawer>
          </>
        ) : (
          // Menú horizontal en desktop
          <>
            {/* Logo centrado arriba */}
            <Box sx={{ mb: 1 }}>
              <Link to="/">
                <IconButton color="inherit" aria-label="logo">
                  <img src={Logo} alt="Logo Marián" className="header-logo" />
                </IconButton>
              </Link>
            </Box>
            <Grid container justifyContent="center" alignItems="center" spacing={4} className="header-menu">
              {sections.map((section) => (
                <Grid item key={section}>
                  {section === "SÍGUENOS" ? (
                    <>
                      <Button
                        color="inherit"
                        className="header-button"
                        onClick={handleSocialMenuOpen}
                        sx={{
                          color: activeSection === section ? "#E66671" : "#3D1C02",
                          fontWeight: "900",
                          fontSize: "14px",
                          backgroundColor: "transparent",
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#E66671",
                          },
                        }}
                      >
                        {section}
                        <ExpandMoreIcon
                          fontSize="medium"
                          className="expand-icon"
                          sx={{
                            marginLeft: "2px",
                          }} />
                      </Button>
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleSocialMenuClose}
                      >
                        <Box sx={{ width: 100, padding: "5px" }}>
                          <Box className="social-container-marian">
                            <Typography variant="body2" className="social-title-marian">
                              Marián®
                            </Typography>
                            <Divider variant="middle" className="social-divider-marian" />
                            <Box className="social-icons-marian">
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.facebook.com/MarianGalletas" target="_blank" rel="noopener noreferrer">
                                  <img src={FacebookMarian} alt="Facebook Marián" className="social-icon" />
                                </a>
                              </MenuItem>
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.instagram.com/galletasmarian/" target="_blank" rel="noopener noreferrer">
                                  <img src={InstagramMarian} alt="Instagram Marián" className="social-icon" />
                                </a>
                              </MenuItem>
                            </Box>
                          </Box>
                          <Box className="social-container-zaks">
                            <Typography variant="body2" className="social-title-zaks">
                              Zak's®
                            </Typography>
                            <Divider variant="middle" className="social-divider-zaks" />
                            <Box className="social-icons-zaks">
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.facebook.com/ZaksMexicoOficial" target="_blank" rel="noopener noreferrer">
                                  <img src={Facebookzaks} alt="Facebook Zaks" className="social-icon" />
                                </a>
                              </MenuItem>
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.instagram.com/zaksmexico/" target="_blank" rel="noopener noreferrer">
                                  <img src={Instagramzaks} alt="Instagram Zaks" className="social-icon" />
                                </a>
                              </MenuItem>
                            </Box>
                          </Box>
                        </Box>
                      </Menu>
                    </>
                  ) : (
                    <Button
                      color="inherit"
                      onClick={() => handleSectionClick(section)}
                      className="header-button"
                      sx={{
                        color: activeSection === section ? "#E66671" : "#3D1C02",
                        fontWeight: "900",
                        fontSize: "14px",
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: activeSection === section ? "#E66671" : "#E66671",
                        },
                      }}
                    >
                      {section}
                    </Button>
                  )}
                </Grid>
              ))}
            </Grid>
          </>
        )
        }
      </Toolbar >

    </AppBar >
  );
}

export default Header;
